<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_1102_1915)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <g filter="url(#filter0_i_1102_1915)">
    <rect
      x="16"
      y="12"
      width="32"
      height="39"
      rx="4"
      fill="url(#paint1_linear_1102_1915)"
    />
  </g>
  <path
    opacity="0.89"
    d="M16 40.7725H48V46.9997C48 49.2089 46.2091 50.9997 44 50.9997H20C17.7909 50.9997 16 49.2089 16 46.9997V40.7725Z"
    fill="url(#paint2_linear_1102_1915)"
  />
  <rect
    x="20.5215"
    y="18"
    width="23.3043"
    height="2.72727"
    rx="1.36364"
    fill="url(#paint3_linear_1102_1915)"
  />
  <rect
    x="20.5215"
    y="22.7725"
    width="23.3043"
    height="2.72727"
    rx="1.36364"
    fill="url(#paint4_linear_1102_1915)"
  />
  <rect
    x="20.5215"
    y="27.5459"
    width="17.3913"
    height="2.72727"
    rx="1.36364"
    fill="url(#paint5_linear_1102_1915)"
  />
  <defs>
    <filter
      id="filter0_i_1102_1915"
      x="16"
      y="12"
      width="32"
      height="39"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood
        flood-opacity="0"
        result="BackgroundImageFix"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="3.5" />
      <feComposite
        in2="hardAlpha"
        operator="arithmetic"
        k2="-1"
        k3="1"
      />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.883333 0 0 0 0 0.883333 0 0 0 0 0.883333 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_1102_1915"
      />
    </filter>
    <linearGradient
      id="paint0_linear_1102_1915"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_1102_1915"
      x1="32"
      y1="12"
      x2="32"
      y2="51"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_1102_1915"
      x1="35.5"
      y1="50.5"
      x2="33.8349"
      y2="37.9877"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="#575757"
      />
    </linearGradient>
    <linearGradient
      id="paint3_linear_1102_1915"
      x1="34.6084"
      y1="20.7273"
      x2="34.6084"
      y2="18.5114"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="#959595"
      />
    </linearGradient>
    <linearGradient
      id="paint4_linear_1102_1915"
      x1="34.6084"
      y1="25.4997"
      x2="34.6084"
      y2="23.2838"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="#959595"
      />
    </linearGradient>
    <linearGradient
      id="paint5_linear_1102_1915"
      x1="31.0341"
      y1="30.2732"
      x2="31.0341"
      y2="28.0573"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="#959595"
      />
    </linearGradient>
  </defs>
</svg>
